import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// The button simply sends the browser to the backend, which owns the entire OAuth flow.
export function GoogleButton({ next = "" }) {
  const { t } = useI18n();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    api.get("/auth/google/status").then((r) => setEnabled(!!r.data?.enabled)).catch(() => setEnabled(false));
  }, []);

  if (!enabled) return null;

  const go = () => {
    const q = next ? `?next=${encodeURIComponent(next)}` : "";
    window.location.href = `${API}/auth/google/login${q}`;
  };

  return (
    <>
      <div className="flex items-center gap-3 my-5 text-xs text-muted-foreground">
        <span className="flex-1 border-t border-border" />{t("auth.or")}<span className="flex-1 border-t border-border" />
      </div>
      <button type="button" onClick={go} className="btn-ghost w-full inline-flex items-center justify-center gap-2.5" data-testid="google-login-btn">
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.5 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.4-3.5z" />
          <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.5 4.5 24 4.5 16.3 4.5 9.7 8.9 6.3 14.7z" />
          <path fill="#4CAF50" d="M24 43.5c5.4 0 10.3-2.1 14-5.4l-6.5-5.3C29.6 34.5 26.9 35.5 24 35.5c-5.3 0-9.7-3.1-11.3-7.5l-6.6 5.1C9.6 39 16.2 43.5 24 43.5z" />
          <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4-4 5.3l6.5 5.3c-.5.4 7-5.1 7-14.6 0-1.2-.1-2.3-.2-3.5z" />
        </svg>
        {t("auth.googleContinue")}
      </button>
    </>
  );
}

export default GoogleButton;
